// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__tz-WC","toolbarButton":"toolbar_toolbarButton__bE5y7"};